







import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class btn extends Vue {
    @Prop({default: false}) isSubmit: boolean;
    @Prop({default: false}) outline: boolean;
}
